import React from 'react';
import { Navbar,Container,Nav } from 'react-bootstrap';
import logo from '../assets/icons/Group 7 (1).png';
import '../css/navbar.css';

const Navigation = () => {
    return (
        <Navbar expand="lg" className="nav-bar py-4 py-lg-2">
            <Container>
                <Navbar.Brand href="#home">
                    <img src={logo} alt="logo" className="img-fluid logo-icon" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" className="nav-toggle-menu" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto d-flex align-items-center">
                        <Nav.Link href="#home" className="pe-5">FAQs</Nav.Link>
                        <Nav.Link href="#link">
                            <button className="linear-btn">GET IN TOUCH</button>
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default Navigation
